/*
 * @Description: 积分商城优惠券兑换弹窗
 * @FilePath: /zeelool-nextjs/src/app/account/points-mall/components/CouponRedeemDialog/index.tsx
 * @Author: 刘行 liuhang@nextmar.com
 * @Date: 2025-04-29 14:03:11
 * @LastEditors: 刘行 liuhang@nextmar.com
 * @LastEditTime: 2025-06-06 16:31:58
 */

import { fetchPointsMallCouponDetail } from '@/api/account';
import { IPointsMallCouponDetail, IPointsMallInfo, IRedeemableItem } from '@/api/types/account';
import SkeletonLoader from '@/app/[variants]/account/redeemable-items/components/RedeemedDetailDialog/SkeletonLoader';
import {
  ContentSection,
  StyledDialog,
} from '@/app/[variants]/account/redeemable-items/components/RedeemedDetailDialog/ui-components';
import Coupon from '@/components/Coupon/coupon';
import { couponDateTransform } from '@/components/Coupon/handler';
import { ICouponProps } from '@/components/Coupon/type';
import { useStore } from '@/providers/app-store-provider';
import { font } from '@/theme/zeelool.theme';
import logger from '@/utils/client-logger';
import { Box, Typography } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import { useEffect, useState } from 'react';
import BenefitTerms from './BenefitTerms';
import FixedBottomButton from './FixedBottomButton';
import HowItWorks from './HowItWorks';
import RedemptionTerms from './RedemptionTerms';

interface CouponRedeemDialogProps {
  show: boolean;
  onClose: () => void;
  item: IRedeemableItem;
  pointsMallData: IPointsMallInfo;
  refreshFreeData: () => void;
}
const CouponRedeemDialog = ({
  show,
  onClose,
  item,
  pointsMallData,
  refreshFreeData,
}: CouponRedeemDialogProps) => {
  const t = useTranslations('account.pointsMall.couponRedeemDialog');
  const currency = useStore((state) => state.currency);
  const couponT = useTranslations('coupons');
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState<IPointsMallCouponDetail | any>(null);
  const [coupon, setCoupon] = useState<ICouponProps>(null);
  useEffect(() => {
    setLoading(true);
    getCouponDetail();
  }, [show]);

  const getCouponDetail = async () => {
    try {
      const { data } = await fetchPointsMallCouponDetail(item.id);
      setDetail(data);
      setCoupon(couponDateTransform(data, false, couponT, currency));
      setLoading(false);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <StyledDialog open={show} onClose={onClose} footer={null}>
      {loading || !detail ? (
        <SkeletonLoader />
      ) : (
        <Box className="relative">
          <div className="top-0 left-0 absolute bg-auxiliary-light-gray w-[400px] h-[400px] flex items-center justify-center">
            <div className="w-[356px]">
              <Coupon
                id={coupon.id}
                couponType={coupon.couponType}
                couponUIType={coupon.couponUIType}
                disCountText={coupon.disCountText}
                title={coupon.title}
                description={coupon.description}
                buttonText={coupon.buttonText}
                copyWriting={coupon.copyWriting}
                isPointsMall
              />
            </div>
          </div>

          <ContentSection>
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontFamily: font.bb,
                fontSize: '32px',
                mb: 1,
              }}
            >
              {Number(detail?.model_type) === 4 ? t('shippingCoupon') : t('coupon')}
            </Typography>
            <div className="text-16 text-warning font-bb leading-[19px] mt-24">
              {detail.point > 1
                ? t('points_plural', { points: detail.point })
                : t('points', { points: detail.point })}
            </div>
            <div className="text-14 leading-[19px] mt-16 mb-24">
              {t('yourPoints', { points: pointsMallData?.points })}
            </div>
            <RedemptionTerms couponInfo={detail} />
            <BenefitTerms couponInfo={detail} />
            <HowItWorks />
            {/* 底部空间，确保内容可以滚动到底部按钮之上 */}
            <Box className="h-[52px]" />
          </ContentSection>
          <FixedBottomButton
            detail={detail}
            refreshFreeData={refreshFreeData}
            pointsMallData={pointsMallData}
            // onClose={onClose}
          />
        </Box>
      )}
    </StyledDialog>
  );
};

export default CouponRedeemDialog;
